// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_group-module--container--3KeoY"};